import { message } from 'antd'
import { CargoApi } from '../../../../api/Purchase/Cargo'
import CargoLines from '../../../../components/Purchasing/Cargo/Lines/CargoLines'
import { pick } from 'lodash'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function CargoLinesCont (props) {
  const { cargo, type, isUpdatable } = props

  const { list, fetching, fetch } = useFetchList(() => CargoApi.getLinesByCargo(cargo._key))

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, CargoApi.lines.update, CargoApi.lines.remove, undefined)

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await CargoApi.lines.create({
        ...newObject,
        cargo: pick(cargo, '_id'),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <CargoLines
      {...{
        list,
        isUpdatable,
        fetching,
        fetch,
        visible,
        submitting,
        cargo,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

CargoLinesCont.propTypes = {}
CargoLinesCont.defaultProps = {}

export default (CargoLinesCont)
